import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Phone } from "lucide-react";
const navStyle = {
  height: "70px",
  width: "100%",
  backgroundColor: "#1A1A1A",
  color: "rgb(26, 26, 26)",
  fontFamily: "Inter, system-ui, -apple-system, sans-serif"
};
const desktopMenuStyle = {
  gap: "32px"
};
const desktopMenuLinkStyle = {
  fontFamily: "Inter, system-ui, -apple-system, sans-serif",
  fontWeight: 400,
  fontSize: "14px",
  color: "#E51F26",
  textDecoration: "none"
};
const phoneIconStyle = {
  gap: "6px"
};
const phoneLinkStyle = {
  fontFamily: "Inter, system-ui, -apple-system, sans-serif",
  fontWeight: 500,
  fontSize: "14px",
  color: "#E51F26",
  textDecoration: "none"
};
const buttonStyle = {
  width: "32px",
  height: "32px",
  gap: "5px",
  background: "none",
  border: "none",
  padding: 0
};
const hamburgerLineStyle = {
  display: "block",
  width: "22px",
  height: "2px",
  backgroundColor: "#E51F26",
  borderRadius: "2px"
};
const sheetStyle = {
  backgroundColor: "#FFFFFF"
};
const mobileMenuStyle = {
  gap: "24px"
};
const mobileMenuLinkStyle = {
  fontFamily: "Inter, system-ui, -apple-system, sans-serif",
  fontWeight: 400,
  fontSize: "16px",
  color: "#E51F26",
  textDecoration: "none"
};
function NavMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [open, setOpen] = useState(false);
  return <nav className="flex items-center justify-between w-full max-w-(--page-max-width) px-4 mx-auto" style={navStyle}>
      <div className="flex items-center">
        <Link to="/">
          <img src="https://full-heron.cynergiasites.com/wp-content/uploads/2026/05/REMLOGO2.webp" alt="REM Technologies DME" className="h-14 md:h-[90px] w-auto" loading="lazy" />
        </Link>
      </div>

      <div className="hidden md:flex items-center" style={desktopMenuStyle}>
        {!loading && menuItems.map((item, i) => {
        const targetTo = item.url?.startsWith("/#") ? item.url.substring(1) : item.url || "#";
        return <Link key={item.id || item.label} to={targetTo} data-index={i} style={desktopMenuLinkStyle} className="hover:text-white transition-colors duration-150">
              {item.label}
            </Link>;
      })}
      </div>

      <div className="hidden md:flex items-center" style={phoneIconStyle}>
        <Phone size={16} color="#E51F26" />
        <Link to="tel:6317403058" style={phoneLinkStyle} className="hover:opacity-80 transition-opacity duration-150">
          631-740-3058
        </Link>
      </div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <button className="md:hidden flex flex-col justify-center items-center cursor-pointer" style={buttonStyle} aria-label="Open menu">
            <span style={hamburgerLineStyle} />
            <span style={hamburgerLineStyle} />
            <span style={hamburgerLineStyle} />
          </button>
        </SheetTrigger>
        <SheetContent side="right" style={sheetStyle}>
          <SheetHeader>
            <SheetTitle>
              <div className="flex items-center">
                <Link to="/" onClick={() => setOpen(false)}>
                  <img src="https://full-heron.cynergiasites.com/wp-content/uploads/2026/05/REMLOGO2.webp" alt="REM Technologies DME" className="h-14 md:h-[70px] w-auto" loading="lazy" />
                </Link>
              </div>
            </SheetTitle>
          </SheetHeader>
          <div className="flex flex-col mt-8" style={mobileMenuStyle}>
            {!loading && menuItems.map((item, i) => {
            const targetTo = item.url?.startsWith("/#") ? item.url.substring(1) : item.url || "#";
            return <Link key={item.id || item.label} to={targetTo} onClick={() => setOpen(false)} data-index={i} style={mobileMenuLinkStyle} className="hover:opacity-70 transition-opacity duration-150">
                  {item.label}
                </Link>;
          })}
            <div className="flex items-center" style={{
            ...phoneIconStyle,
            marginTop: "8px"
          }}>
              <Phone size={16} color="#E51F26" />
              <Link to="tel:6317403058" style={phoneLinkStyle}>
                631-740-3058
              </Link>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </nav>;
}
export default function Header() {
  return <header id="header" className="sticky top-0 z-50 w-full h-[70px] m-0 flex items-center" style={{
    backgroundColor: "#1A1A1A",
    borderBottom: "1px solid #EAE9E4",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&family=Cormorant+Garamond:wght@400;600;700&display=swap');`}</style>
      <MenuProvider menu_id="2" className="w-full">
        <NavMenuContent />
      </MenuProvider>
    </header>;
}